import {createFileRoute} from '@tanstack/react-router';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {CreateModelWizard} from '~components/models/new-model/CreateModelWizard';

export const Route = createFileRoute('/models/new')({
  component: CreateModelPage,
});

function CreateModelPage() {
  return (
    <BaseLayout customContentAndFooter>
      <CreateModelWizard />
    </BaseLayout>
  );
}
